import React from "react";
import { Helmet } from "react-helmet";
import _get from "lodash/get";
import meta from "../config/meta";

const PageHeaders = ({ title, name, content, type }) => (
  <Helmet>
    <noscript>
      {`
      <img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=351574321062228&ev=PageView&noscript=1"/>
      `}
    </noscript>
    <script src="https://use.fontawesome.com/98129ee481.js" />
    {/* <script
      id="ze-snippet"
      src="https://static.zdassets.com/ekr/snippet.js?key=08a99751-16ff-413b-967d-0613e4d8ef84"
    /> */}

    {/* LinkedIn Tracking */}
    <script type="text/javascript">
      {`
      _linkedin_partner_id = "3558916";
      window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
      window._linkedin_data_partner_ids.push(_linkedin_partner_id);
      `}
    </script>
    <script type="text/javascript">
      {`
      (function(l) {
      if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};
      window.lintrk.q=[]}
      var s = document.getElementsByTagName("script")[0];
      var b = document.createElement("script");
      b.type = "text/javascript";b.async = true;
      b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
      s.parentNode.insertBefore(b, s);})(window.lintrk);
    `}
    </script>
    <noscript>
      {`
        <img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=3558916&fmt=gif" />
      `}
    </noscript>


    <title>{_get(meta, `${type}.title`) || meta.default.title}</title>
    <meta
      name="og:title"
      content={_get(meta, `${type}.title`) || meta.default.title}
    />
    <meta
      name="title"
      content={_get(meta, `${type}.title`) || meta.default.title}
    />
    <meta
      name="description"
      content={_get(meta, `${type}.description`) || meta.default.description}
    />
    <meta
      name="og:description"
      content={_get(meta, `${type}.description`) || meta.default.description}
    />
    <meta
      name="og:image"
      content={_get(meta, `${type}.image`) || meta.default.image}
    />
    <meta
      name="og:url"
      content={_get(meta, `${type}.url`) || meta.default.url}
    />
    {/* <script type="text/javascript">
      {`
        window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};
        heap.load("2195058350");
      `}
    </script> */}
  </Helmet>
);

export default PageHeaders;
